<i18n>
en:
  capacity:
    label: "Baggage Capacity"
  time:
    label: "Business Hours"
  holiday:
    label: "Shop Holiday"
  sameday:
    label: "Same-day Reservation"
    available: "Available"
    unavailable: "Unavailable"
  site:
    label: "Shop Website"
  address:
    label: "Address"
  access:
    label: "Access"
    station: " St."
  facility:
    label: "Facility"
  walk:
    label:
    unit: "Minute Walk"
  submit:
    label: "Reservation"
  phone:
    label: "Phone Number"
ja:
  capacity:
    label: "保管可能バッグ数"
  time:
    label: "営業時間"
  holiday:
    label: "定休日"
  sameday:
    label: "当日予約"
    available: "可"
    unavailable: "不可"
  site:
    label: "店舗ホームページ"
  address:
    label: "住所"
  access:
    label: "アクセス"
    station: "駅"
  facility:
    label: "設備"
  walk:
    label: "徒歩"
    unit: "分"
  submit:
    label: "予約"
  phone:
    label: "電話番号"
cn:
  time:
    label: "营业时间"
  holiday:
    label: "定期休假"
  sameday:
    label: "当天预订"
  site:
    label: "存储主页"
  equipment:
    label: "设备"
  walk:
    label: "步行"
    unit: "分钟"
  submit:
    label: "保留"
</i18n>

<template lang="pug">
  div.shop
    div.shop-contents
      v-row(justify="center")
        v-col(cols="12")
          v-carousel(cycle hide-delimiters show-arrows-on-hover)
            v-carousel-item(v-for="(image, index) in shop.shopImgList" :key="index" :src="'data:image/png;base64,' + image.imgSrc" :alt="image.imgTxt")

      br

      v-col(cols="12" align="center")
        |{{shop.industryName}}
        h1
          v-icon|fa-store
          |{{shop.shopName}}

      br
      br

      v-container
        v-row
          v-col(cols="12" sm="6")
            v-text-field.font-weight-black.text-h6(prepend-icon="fa-luggage-cart" :value="$t('capacity.label')" readonly)
          v-col(cols="12" sm="6")
            v-text-field.pl-8.pl-md-2(:value="shop.capa" readonly)
            //-スペース入れるときは｢' ' + ...｣

        //-2: 営業時間
        v-row(v-for="(item, index) in shop.shopOpenTimeList" :key="`opentime-${index}`")
          v-col(v-if="index==0" cols="12" sm="6")
            v-text-field.font-weight-black(prepend-icon="fa-door-open" :value="$t('time.label')" readonly)
          v-col.d-none.d-sm-block(v-else cols="12" sm="6")
          v-col.pl-10.pl-md-5(cols="12" sm="6")
            v-text-field.pl-1.pl-md-0(:value="$t(index + 1) + '. ' + utils.cast.timeDisplay(item.startTime) + ' - ' + utils.cast.timeDisplay(item.endTime)" readonly)  //-plの違い，time形式に，v-if，上下のスペース
          //-|{{item.startTime | time}} ～ {{item.endTime | time}}

        //-3: 定休日
        v-row
          v-col(cols="12" sm="6")
            v-text-field.font-weight-black(prepend-icon="fa-calendar-times" :value="$t('holiday.label')" readonly)
          v-col.pl-10.pl-md-5(cols="12" sm="6")
            v-text-field.pl-1.pl-md-0(v-if="shop.shopHolidayWeekStrList" :value="shop.shopHolidayWeekStrList.join('・')" readonly) //-書き方

        //-4: 当日予約
        v-row
          v-col(cols="12" sm="6")
            v-text-field.font-weight-black(prepend-icon="fa-clipboard-check" :value="$t('sameday.label')" readonly)
          v-col.pl-10.pl-md-5(cols="12" sm="6")
            v-text-field.pl-1.pl-md-0(:value="shop.reserveToday == 1 ? $t('sameday.available') : $t('sameday.unavailable')" readonly)

        //-5: 店舗ホームページ
        v-row
          v-col(cols="12" sm="6")
            v-text-field.font-weight-black(prepend-icon="fa-link" :value="$t('site.label')" readonly)
          v-col.pl-10.pl-md-5.pt-8.pb-8(cols="12" sm="6")
            a.pl-1.pl-md-0(:href="shop.url" target="_blank")|{{shop.url}}

        //-6: 住所
        v-row
          v-col(cols="12" sm="6")
            v-text-field.font-weight-black(prepend-icon="fa-map-marked" :value="$t('address.label')" readonly)
          v-col.pl-10.pl-md-5(cols="12" sm="6")
            v-text-field.pl-1.pl-md-0(:value="shop.address" readonly)

        //-7: 電話番号
        v-row
          v-col(cols="12" sm="6")
            v-text-field.font-weight-black(prepend-icon="fa-phone" :value="$t('phone.label')" readonly)
          v-col.pl-10.pl-md-5(cols="12" sm="6")
            v-text-field.pl-1.pl-md-0(:value="shop.tel" readonly)

        //-8: アクセス
        v-row(v-for="(item,index) in shop.shopStationList" :key="`shopStation-${index}`")
          v-col(v-if="index==0" cols="12" sm="6")
            v-text-field.font-weight-black(prepend-icon="fa-subway" :value="$t('access.label')" readonly)
          v-col.d-none.d-sm-block(v-else cols="12" sm="6")
          v-col.pl-10.pl-md-5(cols="12" sm="6")
            v-text-field.pl-1.pl-md-0(:value="$t(index + 1) + '. ' + item.stationName + $t('access.station') + ' ' + $t('walk.label') + item.walkMinute + $t('walk.unit')" readonly)

        //-9: 設備
        v-row(v-for="(item,index) in shop.shopenvNameList" :key="`shopEnv-${index}`")
          v-col(v-if="index==0" cols="12" sm="6")
            v-text-field.font-weight-black(prepend-icon="fa-shapes" :value="$t('facility.label')" readonly)
          v-col.d-none.d-sm-block(v-else cols="12" sm="6")
          v-col.pl-10.pl-md-5(cols="12" sm="6")
            v-text-field.pl-1.pl-md-0(:value="$t(index + 1) + '. ' + item")

    v-row
      v-col(cols="12" align="center")
        v-btn(x-large color="primary" :to="{name: 'Reserve', params: {id: this.$route.params.id}}")|{{$t('submit.label')}}

</template>

<script>
export default {
  data () {
    return {
      // 店舗
      shop: {},
      // 読込中
      isLoading: false
    }
  },
  created () {
    this.loadShop()
  },
  methods: {
    /**
     * 店舗を読込
     */
    loadShop () {
      this.isLoading = true

      this.api.shop({
        shopId: this.utils.cast.int(this.$route.params.id)
      })
        .then(response => {
          this.shop = response.data
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>

</style>
